module.exports = __webpack_public_path__ + "img/Web-Login.19b26e68.jpg";